function formatValue(value) {
  if (value == null || Number.isNaN(value)) {
    return '-';
  }

  if (Number.isInteger(value)) {
    return String(value);
  }

  if (Math.abs(value) >= 100) {
    return value.toFixed(1);
  }

  if (Math.abs(value) >= 1) {
    return value.toFixed(2);
  }

  return value.toFixed(4);
}

export {
  formatValue,
};
